import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { colors, frames } from '../../../../Styles';
import { PageHeader, UserAndFarmSettings, SystemSettings, UserAdministration, Overlay} from '../../../../Components';
import { Pages } from '../../../../Navigation/root';

export default function GlobalSettings() {
  const { t } = useTranslation()
  const [editUserAndFarmSettings, setEditUserAndFarmSettingse] = useState(false);
  const [editSystemSettings, setEditSystemSettings] = useState(false);

  const seperator = <div style={{ width: "95%", height: "2px", borderTop: "2px solid "+colors.greyDarkPrimary }} />

  return (
    <frames.Page_inner>
      {editUserAndFarmSettings || editSystemSettings ? <Overlay overrides={{}} beforeUnload onClickAlert /> : <></>}
      
      <PageHeader topHeader={t(`menuHeaders.${Pages.globalSettings}`, {defaultValue: "global settings"})} subHeader={t("menuHeaders.overview", {defaultValue: "overview"})}/>
      <frames._page_inner_content_scroll>
        
        <div style={{display: "flex", gap: "20px", alignItems: "center", justifyContent: "center", flexDirection: "column"}}>
          {seperator}
          <UserAndFarmSettings onDirtyChange={setEditUserAndFarmSettingse} zIndex={editUserAndFarmSettings ? 9999 : undefined} />
          {seperator}
          <SystemSettings onDirtyChange={setEditSystemSettings} zIndex={editSystemSettings ? 9999 : undefined} />
          {seperator}
          <UserAdministration/>
        </div>
        
      </frames._page_inner_content_scroll>
    </frames.Page_inner>
  );
}